var render = function render(){var _vm=this,_c=_vm._self._c,_setup=_vm._self._setupProxy;return _c('div',_vm._l((_vm.queryFilters),function(f){return _c('v-chip',{key:f.toDisplay,staticClass:"ma-2",attrs:{"close":"","color":"primary"},on:{"click:close":function($event){return _vm.removeFilter(f)}}},[_vm._v(" "+_vm._s(f.toDisplay)+" ")])}),1)
}
var staticRenderFns = []

export { render, staticRenderFns }